





































import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class FilterBar extends Vue {
	@Prop({
		type: Object,
		required: false,
		default: () => {
			return {}
		}
	})
	private data!: any
	private onSearchClick (): void {
		this.$emit('on-search', this.getFilterParams())
	}
	private getFilterParams () {
		return {
			bill_state: this.data.orderStateSelected,
			start_date: this.data.bussinessDate ? this.data.bussinessDate[0] : '',
			end_date: this.data.bussinessDate ? this.data.bussinessDate[1] : '',
			sort: this.data.orderSortSelected,
			fromOrganName: this.data.fromOrginName,
			toOrginName: this.data.toOrginName,
			orderNo: this.data.orderNo
		}
	}
}
